/* Gravur-MAX Produktseite: Bewertungszeile, Anzeigetitel, Pflichtfeld-Pruefung, mobile Kaufleiste, Tabs */
(function(){
if(window.__gmExtras)return;
window.__gmExtras=true;
function ready(fn){if(document.readyState!=='loading')fn();else document.addEventListener('DOMContentLoaded',fn);}
function $(s,r){return (r||document).querySelector(s);}
var STAR='<svg viewBox="0 0 20 20" aria-hidden="true" focusable="false"><path d="M10 1.6l2.5 5.3 5.8.7-4.3 4 1.1 5.7L10 14.5l-5.1 2.8 1.1-5.7-4.3-4 5.8-.7z" fill="currentColor"/></svg>';

/* 1. Anzeigetitel (Produkttitel selbst bleibt fuer SEO/Shopping unveraendert) */
function title(){
var h=$('.product__info-container .product__title h1');
if(!h||h.getAttribute('data-gm-t'))return;
var t=h.textContent.trim();
if(!/DEINE WUNSCHNAMEN oder TEXT MIT/i.test(t))return;
var kind=(t.match(/^(\S+?)glas\b/i)||[])[1];
var model=(t.match(/Leonardo\s+(\S+)/i)||[])[1]||'';
if(!kind)return;
var two=/2\s*Gl(ä|ae)ser/i.test(t);
var mot='';
document.querySelectorAll('variant-selects-cust a.mo-item').forEach(function(a){if(a.getAttribute('href').split('?')[0]===location.pathname){var x=a.querySelector('.item-title');if(x)mot=x.textContent.trim();}});
if(!mot){var m=t.match(/TEXT MIT ([^"“]+)["“]/i);if(m)mot=m[1].trim().toLowerCase().replace(/(^|\s|-)\S/g,function(c){return c.toUpperCase();});}
h.setAttribute('data-gm-t',t);
h.textContent=kind+(two?'gläser':'glas')+' mit Gravur'+(mot?' „'+mot+'“':'');
var sub=document.createElement('p');
sub.className='gm-subtitle';
sub.textContent=(model?'Leonardo '+model+' · ':'')+(two?'2 Gläser':'1 Glas')+' · mit Wunschtext und Wunschname';
h.parentNode.insertBefore(sub,h.nextSibling);
}

/* 2. Shop-Bewertung ueber dem Titel (aus dem Judge.me-Widget) */
function rating(){
var h=$('.product__info-container .product__title');
if(!h||$('.gm-rating'))return;
var tries=0;
(function poll(){
var a=$('.jdgm-cards-carousel .jdgm-average-rating, .jdgm-carousel .jdgm-average-rating');
var txt=a?a.textContent:'';
var m=txt.match(/(\d+[.,]\d+)/),c=txt.match(/\((\d+)\)/);
var cnt=$('.jdgm-cards-carousel .jdgm-reviews-count');
var n=c?c[1]:(cnt?cnt.textContent.replace(/\D/g,''):'');
if(!m||!n){if(tries++<40)setTimeout(poll,400);return;}
var v=parseFloat(m[1].replace(',','.'));
var full=Math.round(v),s='';
for(var i=0;i<5;i++)s+='<span class="gm-rating__s'+(i<full?'':' is-off')+'">'+STAR+'</span>';
var el=document.createElement('a');
el.className='gm-rating';
el.href='#gm-reviews';
el.innerHTML='<span class="gm-rating__stars" aria-hidden="true">'+s+'</span><span class="gm-rating__t"><strong>'+v.toFixed(1).replace('.',',')+'</strong> · '+n+' Bewertungen</span>';
el.setAttribute('aria-label','Shop-Bewertung '+v.toFixed(1).replace('.',',')+' von 5 aus '+n+' Bewertungen. Zu den Bewertungen springen');
var target=a.closest('.shopify-section')||a;
target.id=target.id||'gm-reviews';
el.href='#'+target.id;
el.addEventListener('click',function(e){e.preventDefault();var hd=document.querySelector('.section-header, sticky-header, header');var off=(hd?hd.getBoundingClientRect().height:0)+16;window.scrollTo({top:target.getBoundingClientRect().top+window.pageYOffset-off,behavior:'smooth'});});
el.style.margin='0 0 .6rem';
var h1=h.querySelector('h1');
if(h1)h1.parentNode.insertBefore(el,h1);else h.insertAdjacentElement('afterbegin',el);
})();
}

/* 3. Pflichtfelder pruefen, bevor das Theme absendet */
var MSG='Bitte ausfüllen oder „Leer lassen“ anhaken.';
function clearErr(f){f.classList.remove('is-error');var m=f.querySelector('.gm-err');if(m)m.remove();}
function validate(){
var G=window.GM;
if(!G||!G.rows||!G.wrap)return true;
if(G.syncFonts)try{G.syncFonts();}catch(e){}
var first=null;
G.rows.forEach(function(r){
var f=r.input.closest('.gm-field');
if(!f)return;
if((r.input.value||'').trim()){clearErr(f);return;}
if(!f.classList.contains('is-error')){
f.classList.add('is-error');
var p=document.createElement('p');
p.className='gm-err';
p.id=(r.input.id||'gm')+'-err';
p.setAttribute('role','alert');
p.textContent=MSG;
f.appendChild(p);
r.input.setAttribute('aria-invalid','true');
r.input.setAttribute('aria-describedby',p.id);
}
if(!first)first=r;
});
if(!first)return true;
if(G.setActive)G.setActive(first.glass||G.nums[0],true);
setTimeout(function(){
var f=first.input.closest('.gm-field')||first.input;
var y=f.getBoundingClientRect().top+window.pageYOffset-120;
window.scrollTo({top:y,behavior:'smooth'});
try{first.input.focus({preventScroll:true});}catch(e){first.input.focus();}
},60);
return false;
}
function bindValidation(){
var G=window.GM;
if(!G||!G.rows||G.__val)return;
G.__val=true;
G.rows.forEach(function(r){
r.input.addEventListener('input',function(){var f=r.input.closest('.gm-field');if(f&&r.input.value.trim()){clearErr(f);r.input.removeAttribute('aria-invalid');}});
var f=r.input.closest('.gm-field'),sk=f&&f.querySelector('.gm-skip input');
if(sk)sk.addEventListener('change',function(){setTimeout(function(){if(r.input.value.trim()){clearErr(f);r.input.removeAttribute('aria-invalid');}},0);});
});
document.addEventListener('click',function(e){
var b=e.target.closest('.product-form__submit, .shopify-payment-button__button, .gm-bar__btn');
if(!b||!$('.gm-cfg'))return;
if(!validate()){e.preventDefault();e.stopImmediatePropagation();}
},true);
document.addEventListener('submit',function(e){
if(!e.target.closest||!e.target.closest('product-form, form[action*="/cart/add"]')||!$('.gm-cfg'))return;
if(!validate()){e.preventDefault();e.stopImmediatePropagation();}
},true);
}

/* 4. Mobile Kaufleiste */
function bar(){
var atc=$('.product__info-container .product-form__submit');
var box=$('.product__info-container .product-atc-btn')||atc;
var price=$('.product__info-container .price');
if(!atc||!box||$('.gm-bar'))return;
var el=document.createElement('div');
el.className='gm-bar';
el.setAttribute('aria-hidden','true');
el.innerHTML='<div class="gm-bar__p"><strong class="gm-bar__v"></strong><span>inkl. MwSt.</span></div><button type="button" class="gm-bar__btn" tabindex="-1">In den Warenkorb</button>';
document.body.appendChild(el);
var v=el.querySelector('.gm-bar__v');
function upd(){
var m=(atc.textContent||'').match(/(\d+)[.,](\d{2})/);
if(!m){var p=price&&price.querySelector('.price-item--sale, .price-item--regular');m=p&&p.textContent.match(/(\d+)[.,](\d{2})/);}
if(m)v.textContent=m[1]+','+m[2]+' €';
}
upd();
new MutationObserver(upd).observe(atc,{childList:true,subtree:true,characterData:true});
el.querySelector('button').addEventListener('click',function(){
if(!validate())return;
atc.click();
});
var past=false,inBox=false;
function show(){
var a=document.activeElement,typing=a&&a.matches&&a.matches('.gm-cfg input[type=text], .gm-cfg textarea');
var on=past&&!inBox&&!typing&&window.matchMedia('(max-width: 749px)').matches;
el.classList.toggle('is-on',on);
el.setAttribute('aria-hidden',on?'false':'true');
el.querySelector('button').tabIndex=on?0:-1;
document.body.classList.toggle('gm-bar-on',on);
}
if('IntersectionObserver' in window){
new IntersectionObserver(function(es){es.forEach(function(e){inBox=e.isIntersecting;});show();}).observe(box);
var ref=price||$('.product__info-container .product__title');
if(ref)new IntersectionObserver(function(es){es.forEach(function(e){past=!e.isIntersecting&&e.boundingClientRect.top<0;});show();}).observe(ref);
}
window.addEventListener('resize',show);
document.addEventListener('focusin',show);
document.addEventListener('focusout',function(){setTimeout(show,50);});
}

/* 5. Reiter "Alles Wichtige": als echte Tabs auszeichnen, per Tastatur bedienbar */
function tabs(){
document.querySelectorAll('.productInnerDetails .tabs-container').forEach(function(tc){
var list=tc.querySelector('.tab-headings .swiper-wrapper')||tc.querySelector('.tab-headings');
var btns=[].slice.call(tc.querySelectorAll('.tab-button'));
if(!list||!btns.length||list.getAttribute('role'))return;
list.setAttribute('role','tablist');
list.removeAttribute('aria-live');
function sync(){btns.forEach(function(b){var on=b.classList.contains('active'),p=document.getElementById(b.getAttribute('data-tab'));b.setAttribute('aria-selected',on?'true':'false');b.tabIndex=on?0:-1;if(p){p.setAttribute('role','tabpanel');p.setAttribute('aria-labelledby',b.id);p.tabIndex=0;}});}
btns.forEach(function(b,i){
b.setAttribute('role','tab');
b.removeAttribute('aria-label');
b.id=b.id||'gm-tab-'+i;
b.setAttribute('aria-controls',b.getAttribute('data-tab'));
b.addEventListener('click',function(){setTimeout(sync,0);});
b.addEventListener('keydown',function(e){
var k=e.key,n=null;
if(k==='Enter'||k===' '){e.preventDefault();b.click();return;}
if(k==='ArrowRight')n=btns[(i+1)%btns.length];
if(k==='ArrowLeft')n=btns[(i-1+btns.length)%btns.length];
if(k==='Home')n=btns[0];
if(k==='End')n=btns[btns.length-1];
if(n){e.preventDefault();n.click();n.focus();}
});
});
sync();
});
}

/* 6. Gravurfelder: klar beschriften, wo welcher Text steht, und Position in der Vorschau markieren */
function posIcon(top){
var on='#0b6e8a',off='#cfd6da';
return '<svg class="gm-pos" viewBox="0 0 28 28" aria-hidden="true" focusable="false"><rect x=".75" y=".75" width="26.5" height="26.5" rx="6" fill="#fff" stroke="#cfd6da" stroke-width="1.5"/><rect x="6" y="6.5" width="16" height="3.5" rx="1.75" fill="'+(top?on:off)+'"/><path d="M14 17.2l-2.5-2.3a1.45 1.45 0 012.5-1.5 1.45 1.45 0 012.5 1.5z" fill="#9aa3a8"/><rect x="6" y="19.5" width="16" height="3.5" rx="1.75" fill="'+(top?off:on)+'"/></svg>';
}
function labels(){
var G=window.GM;
if(!G||!G.rows||G.__lbl)return;
G.__lbl=true;
var mot='';
document.querySelectorAll('variant-selects-cust a.mo-item').forEach(function(a){if(a.getAttribute('href').split('?')[0]===location.pathname){var x=a.querySelector('.item-title');if(x)mot=x.textContent.trim();}});
var art=/^(herz|doppelherz)$/i.test(mot)?'dem '+mot:/(linie|ranke)$/i.test(mot)?'der '+mot:'dem Motiv';
var wl=$('.gm-wine'),h1=$('.product__info-container .product__title h1'),tt=h1?(h1.getAttribute('data-gm-t')||h1.textContent):'';
var fl=/sekt/i.test(tt)?'Mit Sekt':/bier/i.test(tt)?'Mit Bier':'';
if(wl&&fl&&wl.lastChild&&wl.lastChild.nodeType===3)wl.lastChild.textContent=' '+fl;
G.rows.forEach(function(r){
var f=r.input.closest('.gm-field');if(!f)return;
var l=f.querySelector('.gm-label');if(!l)return;
var top=r.kind!=='name';
var main='Text '+(top?'über ':'unter ')+art;
l.classList.add('gm-label--pos');
l.innerHTML=posIcon(top)+'<span class="gm-label__w"><span class="gm-label__m">'+main+'</span></span>';
var cb=f.querySelector('.gm-skip input');if(cb)cb.setAttribute('aria-label',main+' leer lassen');
function slots(){return G.wrap?G.wrap.querySelectorAll('[data-g="'+r.glass+'"][data-r="'+(top?'t':'n')+'"]'):[];}
r.input.addEventListener('focus',function(){setTimeout(function(){slots().forEach(function(s){s.classList.add('is-focus');});},0);});
r.input.addEventListener('blur',function(){slots().forEach(function(s){s.classList.remove('is-focus');});});
});
}

/* 7. Zubehoer: Mengenauswahl statt Ein/Aus-Button */
function bundleQty(){
document.querySelectorAll('.product__info-container .bundle-products-wrapper').forEach(function(w){
var q=w.querySelector('.bundle_qty_main'),inp=w.querySelector('.bundle_item_qty'),mi=w.querySelector('.bundle_minus'),pl=w.querySelector('.bundle_plus');
if(!q||!inp||!mi||!pl||q.getAttribute('data-gm'))return;
q.setAttribute('data-gm','1');
var name=(w.querySelector('.bundle-products-title-price a, .bundle-products-title-price h3, .bundle-products-title-price p')||{}).textContent||'Zubehör';
name=name.trim();
q.setAttribute('role','group');
q.setAttribute('aria-label','Menge '+name);
inp.readOnly=true;
inp.setAttribute('inputmode','numeric');
inp.setAttribute('aria-label','Menge '+name);
inp.setAttribute('aria-live','polite');
[[mi,'Menge verringern'],[pl,'Menge erhöhen']].forEach(function(x){
var b=x[0];b.setAttribute('role','button');b.tabIndex=0;b.setAttribute('aria-label',x[1]+': '+name);
b.addEventListener('keydown',function(e){if(e.key==='Enter'||e.key===' '){e.preventDefault();b.click();}});
});
var lab=document.createElement('span');
lab.className='gm-qty__l';
lab.setAttribute('aria-hidden','true');
lab.textContent='Anzahl';
var row=document.createElement('div');
row.className='gm-qty';
q.parentNode.insertBefore(row,q);
row.appendChild(lab);row.appendChild(q);
var st=document.createElement('span');
st.className='gm-qty__s';
row.appendChild(st);
function sync(){var n=+inp.value||0;w.classList.toggle('is-added',n>0);mi.setAttribute('aria-disabled',n>0?'false':'true');st.textContent=n>0?n+' × im Warenkorb dabei':'';}
[mi,pl].forEach(function(b){b.addEventListener('click',function(){setTimeout(sync,30);});});
inp.addEventListener('change',sync);
sync();
});
}

/* 8. Express-Checkout (PayPal o. ae.) nur bei vollstaendiger Gravur; Hinweis */
function guard(){
var G=window.GM,info=$('.product__info-container');
if(!G||!G.rows||!info||G.__guard)return;
G.__guard=true;
var pb=info.querySelector('.shopify-payment-button');
var hint=null;
if(pb){hint=document.createElement('p');hint.className='gm-dc-hint';hint.textContent='Express-Checkout (z. B. PayPal) erscheint, sobald alle Gravurfelder ausgefüllt sind.';pb.parentNode.parentNode.insertBefore(hint,pb.parentNode.nextSibling);}
function ok(){return G.rows.every(function(r){return (r.input.value||'').trim();});}
function tick(){
var v=ok();
if(!v)info.classList.add('paypal-hide');
if(hint)hint.hidden=v;
}
document.addEventListener('input',tick,true);
document.addEventListener('change',tick,true);
setInterval(tick,500);
tick();
}

/* 0. Vorschau mit ?view=…: Parameter beim Wechsel von Motiv/Set behalten */
function keepView(){
var v=new URLSearchParams(location.search).get('view');
if(!v)return;
function add(u){if(!u||u.indexOf('/products/')<0||/[?&]view=/.test(u))return u;return u+(u.indexOf('?')<0?'?':'&')+'view='+encodeURIComponent(v);}
document.querySelectorAll('.product__info-container a[href*="/products/"]').forEach(function(a){a.setAttribute('href',add(a.getAttribute('href')));});
document.querySelectorAll('.product__info-container input[type=radio]').forEach(function(r){if(r.value&&r.value.indexOf('/products/')===0)r.value=add(r.value);});
}

function run(){
if(document.body.className.indexOf('template-glas-')<0&&!$('.gm-cfg'))return;
keepView();
title();
rating();
bindValidation();
bar();
tabs();
labels();
bundleQty();
guard();
}
ready(function(){try{run();}catch(e){if(window.console)console.warn('gm-extras',e);}});
document.addEventListener('gm:cfg-ready',function(){try{bindValidation();labels();guard();}catch(e){}});
})();